import { motion } from "framer-motion";
import { Flame, Phone } from "lucide-react";
import { ORDER_URL } from "@/components/Navbar";

const StickyOrderBar = () => (
  <motion.div
    data-testid="sticky-order-bar"
    initial={{ y: 90 }}
    animate={{ y: 0 }}
    transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-0 left-0 right-0 z-40 lg:hidden px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/85 to-transparent"
  >
    <div className="flex items-center gap-3">
      <motion.a
        data-testid="sticky-order-online-btn"
        href={ORDER_URL}
        target="_blank"
        rel="noopener noreferrer"
        whileTap={{ scale: 0.96 }}
        className="flex-1 flex items-center justify-center gap-2 bg-spice text-cream font-semibold text-base px-6 py-3.5 rounded-full shadow-[0_10px_30px_rgba(198,40,40,0.45)]"
      >
        <Flame size={17} />
        Order Online
      </motion.a>
      <motion.a
        data-testid="sticky-call-btn"
        href="tel:+61408382360"
        whileTap={{ scale: 0.94 }}
        aria-label="Call Kababish"
        className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-gold/60 bg-[#0A1128]/90 text-gold backdrop-blur-md"
      >
        <Phone size={19} />
      </motion.a>
    </div>
  </motion.div>
);

export default StickyOrderBar;
